import {ShareFn} from './share.types'

const MAIL_PROTOCOL = 'mailto:'

export const buildMailShareLink: ShareFn = input => {
  return `${MAIL_PROTOCOL}?body=${encodeURIComponent(input.text)}`
}
